<template>
  <div>
    <div class="row align-items-end">
      <div class="col-xl-4 col-12 my-2">
        <label for="repairPayCustomerSelect"
          >Client <span class="text-danger">*</span></label
        >
        <vue-select
          id="repairPayCustomerSelect"
          :options="customersForSelect"
          :value="customer_reference"
          placeholder="Choisir un client"
          labelColumn="displayName"
          valueColumn="reference"
          @input="onCustomerReferenceInput"
        />
      </div>

      <div class="col-xl-5 col-12 my-2">
        <label for="repairPayRepairSelect"
          >Réparation impayée <span class="text-danger">*</span></label
        >
        <vue-select
          id="repairPayRepairSelect"
          :key="'repair-' + (customer_reference || 'none')"
          :options="repairOptions"
          v-model="form.repair_reference"
          placeholder="Choisir une réparation"
          labelColumn="selectLabel"
          valueColumn="reference"
        />
      </div>

      <div class="col-xl-3 col-12 my-2">
        <label>Montant <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
            type="number"
            step="0.01"
            min="0"
            v-model="form.amount"
            class="form-control"
          />
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="fillAmount"
            title="Montant restant dû"
          >
            <i class="bi bi-arrow-down-circle"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-md-3 my-2">
        <label>Date</label>
        <input type="date" v-model="form.date" class="form-control" />
      </div>
      <div class="col-md-3 my-2">
        <label>Mode de paiement</label>
        <select v-model="form.paymentMethod" class="form-select">
          <option value="Espèce">Espèce</option>
          <option value="Virement bancaire">Virement bancaire</option>
          <option value="Chèque">Chèque</option>
          <option value="Effet">Effet</option>
        </select>
      </div>
      <div class="col-md-3 my-2">
        <label>Nº chèque</label>
        <input
          type="text"
          v-model="form.checkNumber"
          class="form-control"
        />
      </div>
      <div class="col-md-3 my-2">
        <label>Nº virement</label>
        <input
          type="text"
          v-model="form.bankTransferNumber"
          class="form-control"
        />
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-12">
        <label>Remarque</label>
        <textarea
          v-model="form.remark"
          class="form-control"
          rows="2"
        ></textarea>
      </div>
    </div>

    <div class="row mt-4 justify-content-end">
      <div class="col-auto">
        <button class="btn btn-success" type="button" @click="submit">
          <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueSelect from "@/components/cards/VueSelect.vue";

export default {
  components: { VueSelect },
  data() {
    return {
      customer_reference: "",
      form: {
        repair_reference: "",
        amount: "",
        date: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
        paymentMethod: "Espèce",
        checkNumber: "",
        bankTransferNumber: "",
        remark: "",
      },
    };
  },
  computed: {
    ...mapGetters("customer", { customers: "getAll" }),
    ...mapGetters("repair", { unpaidRepairs: "getUnpaidRepairsForPayment" }),
    customersForSelect() {
      return (this.customers || []).map((c) => ({
        reference: c.reference,
        displayName:
          [c.fullName, c.society].filter(Boolean).join(" ").trim() ||
          c.reference ||
          "",
      }));
    },
    repairOptions() {
      return (this.unpaidRepairs || []).map((r) => {
        const veh = r.vehicle
          ? r.vehicle.matricule || r.vehicle.fullName || ""
          : "";
        const reste = this.formatNum(r.amountUnpaid);
        const suffix = veh ? " (" + veh + ")" : "";
        return {
          reference: r.reference,
          selectLabel: r.reference + " — reste " + reste + " DH" + suffix,
        };
      });
    },
    selectedRepair() {
      if (!this.form.repair_reference || !this.unpaidRepairs.length) {
        return null;
      }
      return this.unpaidRepairs.find(
        (r) => r.reference === this.form.repair_reference
      );
    },
  },
  mounted() {
    this.$store.dispatch("customer/getAll");
  },
  beforeDestroy() {
    this.$store.commit("repair/SET_UNPAID_REPAIRS_FOR_PAYMENT", []);
  },
  methods: {
    formatNum(v) {
      if (v == null) return "0";
      return parseFloat(v).toFixed(2);
    },
    /**
     * Client choisi → met à jour customer_reference et charge repairs_unpaid/{ref}.
     * (Nom explicite pour le template @input — évite les handlers undefined.)
     */
    onCustomerReferenceInput(val) {
      var ref =
        val === null || val === undefined || val === ""
          ? ""
          : String(val);
      this.customer_reference = ref;
      this.form.repair_reference = "";
      this.form.amount = "";
      if (!ref) {
        this.$store.commit("repair/SET_UNPAID_REPAIRS_FOR_PAYMENT", []);
        return;
      }
      this.$store.dispatch("repair/getCustomerRepairsUnpaid", ref);
    },
    fillAmount() {
      if (this.selectedRepair) {
        this.form.amount = this.selectedRepair.amountUnpaid;
      }
    },
    submit() {
      if (!this.form.repair_reference) {
        this.$store.dispatch(
          "notification/store",
          {
            status: "error",
            message: "Choisissez une réparation.",
          },
          { root: true }
        );
        return;
      }
      this.$store.dispatch("paymentRepair/store", { ...this.form });
    },
  },
};
</script>
